import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './upload-modal.scss';
import ReportsService from '../../../../../../../../../services/reports-service.js';
import UploadModalContent from '../upload-modal-content/upload-modal-content.js';

const reportsService = new ReportsService();

const UploadModal = ({ show, onClose, selectedReport }) => {
  return (
      <Modal
          show={show}
          onHide={onClose}
          dialogClassName="maker-upload-modal modal-dialog-centered"
      >
          <Modal.Header closeButton>
              <Modal.Title>Upload Document</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <UploadModalContent context={{ report: selectedReport }} onClose={onClose} />
          </Modal.Body>
      </Modal>
  );
};

export default UploadModal;
